module.exports = __webpack_public_path__ + "static/media/niao2.ecde207.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/niao2.mp3
// module id = 9njr
// module chunks = 9